import { render, staticRenderFns } from "./CustomizationDashboard.vue?vue&type=template&id=3f8a3d66&"
import script from "./CustomizationDashboard.vue?vue&type=script&lang=js&"
export * from "./CustomizationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports